import React, { useState } from 'react';
import { Link } from "react-router-dom";
import CabecalhoLink from "components/CabecalhoLink";
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useDevice } from 'components/DeviceContext.js';
import fia from 'imagens/logoFia.png'
import { RedesSociaisLaranja } from 'components/RedesSociais';
import {Grid} from '@material-ui/core'

const Cabecalho = () => {
    const { isMobile, isLaptop, isTablet } = useDevice();
    const [openDrawer, setOpenDrawer] = useState(false);

    const toggleDrawer = () => {
        setOpenDrawer(!openDrawer);
    };

    return (
        <header align="center" style={{backgroundColor:'var(--azul)', display: 'flex', justifyContent: isTablet ? 'space-between' : 'space-around', padding: isMobile ? '0' : isTablet ? '1.8em' : '1.8rem 0 1rem 5rem' , margin: '0'}}  >
            <Link to="./">
            <img src={fia} alt="Logo FIA"
            style={{

                width: isMobile  ? '6em' : isLaptop ?  '9em' : '',
                margin: isMobile ? '1em' : isLaptop ?  '1em' : ''
            }}/>
            </Link>
            {(isMobile || isTablet )&& (
                <>
                    <IconButton
                        edge="start"
                        color="white"
                        aria-label="menu"
                        onClick={toggleDrawer}

                    >
                        <MenuIcon />
                    </IconButton>
                    <Drawer
                        anchor="right"
                        open={openDrawer}
                        onClose={toggleDrawer}
                    >
                        <Grid style={{ width: isMobile ? '168px' : '220px' }}>
                            <CabecalhoLink />
                            <RedesSociaisLaranja />
                        </Grid>
                    </Drawer>
                </>
            )}
            {!(isMobile || isTablet) && (
                <nav >
                    <CabecalhoLink />
                </nav>
            )}
        </header>
    );
}

export default Cabecalho;
